import { VideoSpecs } from './VideoSpecs';
import { addVideo } from './actions';
import { vAction } from './const';
export { videoNodeName, videoType } from './VideoSpecs';
export const Video = (builder, opts) => {
    builder.use(VideoSpecs, opts);
    builder.addAction(vAction, () => addVideo);
};
